import { EvaAddress } from "src/app/domains/address";
import { PaymentCondition, initPaymentConditions } from "src/app/domains/payment-condition";
import { Phone } from "src/app/domains/phone";
import { getTodayUtc } from "src/app/shared/helpers/date.helpers";

import { EvaCompanyAudit } from "../../../domains/audit";
import { VAT } from "../../../domains/vat";
import { Formulas } from "../../formula/models/formula.model";
import { Intervention } from "../../interventions/domains/intervention";
import { MealBreak } from "./meal-break";
import { EvaCompanyBillingConfig } from "./eva-company-billing-config";
import { EvaCompanyExpenseReportConfig } from "./eva-company-expense-report-config";
import { EvaCompanyMobileConfig } from "./eva-company-mobile-config";
import { EvaCompanyPlanningNotificationConfig } from "./eva-company-planning-notification-config";
import { EvaCompanyEmployeesConfig } from "./eva-company-employees-config";
import { EvaCompanyWebActivityButtonsConfig } from "./eva-company-web-activity-buttons-config";
import { Tag } from "./eva-company-tag";
import { InterventionConfig } from "./intervention_config";

export enum EvaCompanyStatus {
  ENABLED = "ENABLED",
  TEST = "TEST",
  DISABLED = "DISABLED",
}

export enum EvaFeatures {
  CORE = "CORE",
  EXPENSE_REPORT = "EXPENSE_REPORT",
  BUDGET_SPECULATIVE = "BUDGET_SPECULATIVE",
  MAINTENANCE_CONTRACT = "MAINTENANCE_CONTRACT",
  SEND_OFFER_TENDER = "SEND_OFFER_TENDER",
  QR_INVOICE = "QR_INVOICE",
  NOTIFICATION_SUMMARY = "NOTIFICATION_SUMMARY",
  PLANNING_NOTIFICATION = "PLANNING_NOTIFICATION",

  OFFERS_V2 = "OFFERS_V2",
  CATALOG = "CATALOG",
  CREDIT_NOTE = "CREDIT_NOTE",
  SCAN_EMAIL = "SCAN_EMAIL",
  INVOICE_V2 = "INVOICE_V2",
  BANKING = "BANKING",
  AUTH_EMAIL = "AUTH_EMAIL",
  NOTIF_PURCHASE_ORDER = "NOTIF_PURCHASE_ORDER",
  PAIN001_BATCH = "PAIN001_BATCH",
  CUSTOMER_SITE = "CUSTOMER_SITE",
  ACCOUNTING = "ACCOUNTING",
  ACCOUNTING_CONFIGURED = "ACCOUNTING_CONFIGURED",
  IGH_CATALOG = "IGH_CATALOG",
  AMFIS_CATALOG = "AMFIS_CATALOG",
  AI_CREDITS = "AI_CREDITS",
  IMPORT_SOUM_PDF = "IMPORT_SOUM_PDF",
  V3_BETA = "V3_BETA",
  NATURE_SERVICE = "NATURE_SERVICE",
  GENOLET = "GENOLET",
  CONVERSATIONS = "CONVERSATIONS",
  AI_ASSISTANT = "AI_ASSISTANT",
}

export class HTMLEntry {
  entry_id: string;
  name: string;
  contentHTML: string;
  type: string;
  document_type: string;

  public static createInstance(jsonData: any): HTMLEntry {
    return Object.assign(new HTMLEntry(), jsonData);
  }

  public static createInstances(jsonData: any[]): HTMLEntry[] {
    return jsonData.map((e) => HTMLEntry.createInstance(e));
  }

  clone() {
    return Object.assign(new HTMLEntry(), this);
  }
}

export class DocumentEvaCompanyApparence {
  fontSize: string;
  fontFamily: string;
  verticalPadding: string;
  horizontalPadding: string;
  color: string;
  customColor: string;
  showAddressBackground: boolean;

  constructor() {
    this.fontSize = "10px";
    this.fontFamily = "'Inter'";
    this.verticalPadding = "50px";
    this.horizontalPadding = "50px";
    this.color = "#5F6CB0";
    this.customColor = "";
    this.showAddressBackground = true;
  }

  public static createInstance(jsonData: any): DocumentEvaCompanyApparence {
    const e = Object.assign(new DocumentEvaCompanyApparence(), jsonData);
    e.customColor = jsonData?.customColor || "";
    e.verticalPadding = jsonData?.verticalPadding || "50px";
    e.fontFamily = jsonData?.fontFamily || "'Inter'";
    e.showAddressBackground = jsonData?.showAddressBackground !== false;
    return e;
  }
}
export class PredifinedTimes {
  predifined_times_id: string;
  label: string;
  value: Times[] = [];

  constructor() {
    this.label = "";
  }

  public static createInstance(jsonData: any): PredifinedTimes {
    const e = Object.assign(new PredifinedTimes(), jsonData);
    if (jsonData.value) {
      e.value = Times.createInstances(jsonData.value);
    }

    return e;
  }

  public static createInstances(jsonData: PredifinedTimes[]): PredifinedTimes[] {
    return jsonData.map((e) => PredifinedTimes.createInstance(e));
  }
}
export class Times {
  times_id: string;
  start: Date;
  end: Date;
  type: string;
  meal_break_request: boolean;

  constructor() {
    this.meal_break_request = false;
  }

  public static createInstance(jsonData: any): Times {
    const e = Object.assign(new Times(), jsonData);
    e.start = jsonData.start ? new Date(jsonData.start) : null;
    e.end = jsonData.end ? new Date(jsonData.end) : null;

    return e;
  }

  public static createInstances(jsonData: Times[]): Times[] {
    return jsonData.map((e) => Times.createInstance(e));
  }
}

export class GlobalConfigOffer {
  is_show_country_in_address: boolean;
  is_show_project: boolean;
  is_show_customer: boolean;
  is_show_employee: boolean;
  is_show_offer: boolean;
  is_show_detailled_recap: boolean;
  is_show_recap: boolean;
  showRecapFirst: boolean;
  isShowsArticleNumber: boolean;
  isShowsDiscountValue: boolean;
  isShowsSellingPriceUnit: boolean;
  isShowsSellingPriceTotal: boolean;
  isShowsQuantity: boolean;
  recap_level: number;
  is_show_signature: boolean;
  is_show_page_number: boolean;

  constructor() {
    this.is_show_country_in_address = false;
    this.is_show_project = true;
    this.is_show_customer = true;
    this.is_show_employee = true;
    this.is_show_offer = true;
    this.is_show_detailled_recap = true;
    this.is_show_recap = false;
    this.showRecapFirst = false;
    this.isShowsArticleNumber = false;
    this.isShowsDiscountValue = false;
    this.isShowsSellingPriceUnit = false;
    this.isShowsSellingPriceTotal = true;
    this.isShowsQuantity = false;
    this.recap_level = 4;
    this.is_show_signature = false;
    this.is_show_page_number = true;
  }

  public static createInstance(jsonData: any): GlobalConfigOffer {
    const e = Object.assign(new GlobalConfigOffer(), jsonData);

    return e;
  }
}

export class AccountingCodesEntry {
  [key: string]: any;
  revenue_works: string = "3200";
  accounts_receivable: string = "1100";
  purchases_materials: string = "4200";
  subcontracting: string = "4400";
  payroll_charges: string = "5000";
  accounts_payable: string = "2000";
  vat_collected: string = "2201";
  vat_deductible: string = "1170";

  public static createInstance(jsonData: any): AccountingCodesEntry {
    return Object.assign(new AccountingCodesEntry(), jsonData ?? {});
  }
}

export class GlobalConfigInvoice {
  is_show_country_in_address: boolean;
  is_show_project: boolean;
  is_show_employee: boolean;
  is_show_offer: boolean;
  is_show_payment_deadline: boolean;
  is_show_detailed_offer: boolean;
  is_show_summary_offer: boolean;
  chift_supplier_account_number: string;
  chift_customer_account_number: string;
  accounting_codes: AccountingCodesEntry = new AccountingCodesEntry();
  default_payment_conditions: PaymentCondition[] = initPaymentConditions.map((c) => new PaymentCondition(c));

  constructor() {
    this.is_show_country_in_address = false;
    this.is_show_project = true;
    this.is_show_employee = true;
    this.is_show_offer = true;
    this.is_show_payment_deadline = true;
    this.is_show_detailed_offer = true;
    this.is_show_summary_offer = false;
    this.chift_customer_account_number = "";
    this.chift_supplier_account_number = "";
    this.accounting_codes = new AccountingCodesEntry();
  }

  public static createInstance(jsonData: any): GlobalConfigInvoice {
    const e = Object.assign(new GlobalConfigInvoice(), jsonData);
    e.accounting_codes = AccountingCodesEntry.createInstance(jsonData?.accounting_codes);
    e.default_payment_conditions = jsonData?.default_payment_conditions?.length
      ? jsonData.default_payment_conditions.map((c) => new PaymentCondition(c))
      : initPaymentConditions.map((c) => new PaymentCondition(c));
    return e;
  }
}

export class OfferSignature {
  name: string;
  display_employee_name: boolean;

  constructor() {
    this.display_employee_name = true;
  }

  public static createInstance(jsonData: any): OfferSignature {
    const e = Object.assign(new OfferSignature(), jsonData);

    return e;
  }
}

export class DocumentEvaCompanyInfo {
  pdfModelOffer: string;
  pdfModelInvoice: string;
  company_infoHTML: string;
  location: string;
  header_list: HTMLEntry[] = [];
  header_invoice_list: HTMLEntry[] = [];
  outro_list: HTMLEntry[] = [];
  outro_invoice_list: HTMLEntry[] = [];
  closing_list: HTMLEntry[] = [];
  closing_invoice_list: HTMLEntry[] = [];
  footer_list: HTMLEntry[] = [];
  annex_list: HTMLEntry[] = [];
  header_selected_id: string;
  header_invoice_selected_id: string;
  outro_selected_id: string;
  outro_invoice_selected_id: string;
  closing_selected_id: string;
  closing_invoice_selected_id: string;
  footer_selected_id: string;
  annex_selected_id: string;
  apparence: DocumentEvaCompanyApparence = new DocumentEvaCompanyApparence();
  global_config_offer: GlobalConfigOffer = new GlobalConfigOffer();
  global_config_invoice: GlobalConfigInvoice = new GlobalConfigInvoice();
  signature: OfferSignature = new OfferSignature();
  logoSize: string;
  locked_sections: string[] = [];
  custom_footer_enabled: boolean = false;
  custom_footer_mode: string = "BLOCKS";
  custom_footer_left_html: string = "";
  custom_footer_center_html: string = "";
  custom_footer_right_html: string = "";
  custom_footer_text_zone: string = "center";
  custom_footer_logo_zone: string = "right";
  custom_footer_pagination_zone: string = "left";
  custom_footer_show_pagination: boolean = true;
  custom_footer_all_pages: boolean = true;
  custom_footer_invoice_enabled: boolean = false;
  custom_footer_invoice_mode: string = "BLOCKS";
  custom_footer_invoice_left_html: string = "";
  custom_footer_invoice_center_html: string = "";
  custom_footer_invoice_right_html: string = "";
  custom_footer_invoice_text_zone: string = "center";
  custom_footer_invoice_logo_zone: string = "right";
  custom_footer_invoice_pagination_zone: string = "left";
  custom_footer_invoice_show_pagination: boolean = true;
  custom_footer_invoice_all_pages: boolean = true;

  isSectionLocked(key: string): boolean {
    return this.locked_sections?.includes(key) ?? false;
  }

  public static createInstance(jsonData: any): DocumentEvaCompanyInfo {
    const e = Object.assign(new DocumentEvaCompanyInfo(), jsonData);
    if (jsonData.header_list) {
      e.header_list = HTMLEntry.createInstances(jsonData.header_list);
    }
    if (jsonData.header_invoice_list) {
      e.header_invoice_list = HTMLEntry.createInstances(jsonData.header_invoice_list);
    }
    if (jsonData.outro_list) {
      e.outro_list = HTMLEntry.createInstances(jsonData.outro_list);
    }
    if (jsonData.outro_invoice_list) {
      e.outro_invoice_list = HTMLEntry.createInstances(jsonData.outro_invoice_list);
    }
    if (jsonData.closing_list) {
      e.closing_list = HTMLEntry.createInstances(jsonData.closing_list);
    }
    if (jsonData.closing_invoice_list) {
      e.closing_invoice_list = HTMLEntry.createInstances(jsonData.closing_invoice_list);
    }
    if (jsonData.footer_list) {
      e.footer_list = HTMLEntry.createInstances(jsonData.footer_list);
    }
    if (jsonData.annexes) {
      e.annex_list = HTMLEntry.createInstances(jsonData.annex_list);
    }
    if (jsonData.apparence) {
      e.apparence = DocumentEvaCompanyApparence.createInstance(jsonData.apparence);
    }
    if (jsonData.global_config_offer) {
      e.global_config_offer = GlobalConfigOffer.createInstance(jsonData.global_config_offer);
    }
    if (jsonData.global_config_invoice) {
      e.global_config_invoice = GlobalConfigInvoice.createInstance(jsonData.global_config_invoice);
    }
    if (jsonData.signature) {
      e.signature = OfferSignature.createInstance(jsonData.signature);
    }
    return e;
  }
}

/** Titre du document d'offre imprimé et envoyé au client, réglable par société. */
export type OfferDocumentLabel = "Offre" | "Devis";

/** « Devis » si la société l'a choisi, « Offre » sinon (valeur absente ou inconnue). */
export function offerDocumentLabel(
  company: Pick<EvaCompany, "offer_document_label"> | null | undefined,
): OfferDocumentLabel {
  return company?.offer_document_label === "Devis" ? "Devis" : "Offre";
}

export class EvaCompany {
  eva_company_id: string;
  name: string;
  address: string;
  address_details: EvaAddress = new EvaAddress();
  mobile_phone_details: Phone = new Phone();
  office_phone_details: Phone = new Phone();
  address_lat: number = 0;
  address_lng: number = 0;
  logo: string;
  url: string;
  phone_mobile: string;
  phone_office: string;
  mail: string;
  vat_number: string;
  local_company_id: string;
  employees: [];
  vat_list: VAT[] = [];
  features_enabled: string[] = [];
  employees_order: string[] = [];
  descHTML: string;
  header_companyHTML: string;
  sign: string;
  billing_config: EvaCompanyBillingConfig = new EvaCompanyBillingConfig();
  expense_report_config: EvaCompanyExpenseReportConfig = new EvaCompanyExpenseReportConfig();
  planning_notification_config: EvaCompanyPlanningNotificationConfig = new EvaCompanyPlanningNotificationConfig();
  mobile_config: EvaCompanyMobileConfig = new EvaCompanyMobileConfig();
  web_activity_buttons_config: EvaCompanyWebActivityButtonsConfig = new EvaCompanyWebActivityButtonsConfig();
  employees_config: EvaCompanyEmployeesConfig = new EvaCompanyEmployeesConfig();
  status: EvaCompanyStatus;
  isShowsOffersV2Only: boolean;

  is_meal_break_allowed: boolean;
  is_other_activity_enabled: boolean = false;
  meal_break_list: MealBreak[] = [];
  planning_predifined_times: PredifinedTimes[] = [];
  doc_info: DocumentEvaCompanyInfo = new DocumentEvaCompanyInfo();
  intervention_config: InterventionConfig = new InterventionConfig();

  doc_headerHTML: string;
  doc_company_infoHTML: string;
  doc_footerHTML: string;
  primaryCurrency: string;
  country: string;
  canton: string;

  offer_intro_default: string;
  offer_outro_default: string;

  name_initials: string;
  company_color: string;

  work_domains: string[] = [];

  force_company_email_sending: boolean = false;
  email_send_mode: string = "default";

  default_workforce_hourly_cost: number = 80;
  resources_forecast_hours_per_week: number = 45;
  resources_forecast_trade_tag_ids: string[] = [];
  default_workforce_goal_margin: number = 25;
  default_use_manager_badge_color: boolean = false;
  default_allow_interventions: boolean = false;
  amfis_hourly_rate: number | null = null;
  amfis_round_50cts: boolean = true;
  amfis_hourly_cost: number | null = null;
  use_catalog_images: boolean = true;
  /** Seuls les administrateurs peuvent créer des étiquettes. */
  tag_creation_admin_only: boolean = false;
  default_article_sell_margin: number = 25;
  default_offer_item_margin: number = 25;
  offer_workflows_enabled: boolean = false;
  /** Titre du document d'offre sur le PDF et l'envoi client. */
  offer_document_label: OfferDocumentLabel = "Offre";
  offer_duplicate_keep_customer: boolean = false;
  offer_duplicate_keep_project: boolean = false;
  invoice_duplicate_keep_customer: boolean = false;
  invoice_duplicate_keep_project: boolean = false;
  invoice_show_project_numbers: boolean = false;

  audits: EvaCompanyAudit[] = [];

  get companyColors() {
    let baseColors: string[] = [
      "#5F6CB0",
      "#BE56AE",
      "#C06464",
      "#3D8989",
      "#B49C22",
      "#CE7055",
      "#9454B1",
      "#659AC2",
      "#C98A4D",
      "#222F3E",
    ];
    // ID CLIMAT
    if (this.eva_company_id === "67b4bc1b505f6af22e5ad7a3") {
      baseColors.push("#1D3B80");
    }

    // simao & deillon
    if (this.eva_company_id === "67ff9b7b9cc9bf9afde91fc2") {
      baseColors.push("#91c57a");
    }

    // Ajouter la couleur personnalisée si définie
    if (this.doc_info?.apparence?.customColor) {
      baseColors.push(this.doc_info.apparence.customColor);
    }

    return baseColors;
  }

  constructor() {
    this.employees = [];
    this.primaryCurrency = "CHF";
    this.country = "CH";
    this.mobile_phone_details = new Phone();
    this.office_phone_details = new Phone();
  }

  public static createInstance(jsonData: any): EvaCompany {
    const e = Object.assign(new EvaCompany(), jsonData);

    if (jsonData.vat_list) {
      e.vat_list = VAT.createInstances(jsonData.vat_list);
    }
    if (jsonData.meal_break_list) {
      e.meal_break_list = MealBreak.createInstances(jsonData.meal_break_list);
    }
    if (jsonData.planning_predifined_times) {
      e.planning_predifined_times = PredifinedTimes.createInstances(jsonData.planning_predifined_times);
    }
    if (jsonData.audits) {
      e.audits = EvaCompanyAudit.createInstances(jsonData.audits);
    }
    if (jsonData.doc_info) {
      e.doc_info = DocumentEvaCompanyInfo.createInstance(jsonData.doc_info);
    }
    if (jsonData.address_details) {
      e.address_details = EvaAddress.createInstance(jsonData.address_details);
    }
    if (jsonData.mobile_phone_details) {
      e.mobile_phone_details = Phone.createInstance(jsonData.mobile_phone_details);
    }
    if (jsonData.office_phone_details) {
      e.office_phone_details = Phone.createInstance(jsonData.office_phone_details);
    }

    if (!jsonData.billing_config) {
      e.billing_config = EvaCompanyBillingConfig.createInstance(new EvaCompanyBillingConfig());
    } else {
      e.billing_config = EvaCompanyBillingConfig.createInstance(jsonData.billing_config);
    }
    if (!jsonData.expense_report_config) {
      e.expense_report_config = new EvaCompanyExpenseReportConfig();
    }
    e.planning_notification_config = EvaCompanyPlanningNotificationConfig.createInstance(
      jsonData.planning_notification_config,
    );
    e.mobile_config = EvaCompanyMobileConfig.createInstance(jsonData.mobile_config);
    e.web_activity_buttons_config = EvaCompanyWebActivityButtonsConfig.createInstance(
      jsonData.web_activity_buttons_config,
    );
    e.employees_config = EvaCompanyEmployeesConfig.createInstance(jsonData.employees_config);
    if (jsonData.intervention_config) {
      e.intervention_config = InterventionConfig.createInstance(jsonData.intervention_config);
    } else {
      e.intervention_config = new InterventionConfig();
    }

    return e;
  }

  public static createInstances(jsonData: any[]): EvaCompany[] {
    return jsonData.map(EvaCompany.createInstance);
  }

  clone(): EvaCompany {
    let v = Object.assign(new EvaCompany(), this);
    v.audits = EvaCompanyAudit.createInstances(v.audits);
    return v;
  }

  hasFeature(feature: EvaFeatures | `${EvaFeatures}`): boolean {
    return this.features_enabled.includes(feature);
  }

  addFeature(feature: EvaFeatures) {
    if (!this.hasFeature(feature)) {
      this.features_enabled = [...this.features_enabled, feature];
    }
  }

  removeFeature(feature: EvaFeatures) {
    this.features_enabled = this.features_enabled.filter((x) => x !== feature);
  }
  getCurrentMealBreak() {
    const currentDate = new Date();
    const sortedMealBreaks = [...this.meal_break_list];
    sortedMealBreaks.sort((a, b) => new Date(b.start_date).getTime() - new Date(a.start_date).getTime());
    for (let i = 0; i < sortedMealBreaks.length; i++) {
      const element = sortedMealBreaks[i];
      if (currentDate >= element.start_date) {
        return element;
      }
    }
    return null;
  }
  getDateMealBreak(date = new Date()) {
    let mealBreaksBefore: MealBreak[] = [];
    this.meal_break_list.forEach((mealBreak) => {
      if (new Date(mealBreak.start_date) < date) {
        mealBreaksBefore.push(mealBreak);
      }
    });
    mealBreaksBefore.sort((a, b) => new Date(b.start_date).getTime() - new Date(a.start_date).getTime());
    if (mealBreaksBefore.length > 0)
      return mealBreaksBefore.reduce((prev, curr) =>
        new Date(prev.start_date) > new Date(curr.start_date) ? prev : curr,
      );
    return null;
  }

  getFirstVat(): VAT {
    if (this.vat_list.length > 0) {
      return this.vat_list[0];
    }
    return null;
  }
}

/** Données minimales pour le sélecteur de société (dropdown switch) */
export interface EvaCompanyLight {
  eva_company_id: string;
  name: string;
  name_initials: string;
  company_color: string;
  country: string;
  primaryCurrency: string;
}

/** Extrait les champs minimaux d'une EvaCompany pour stockage léger dans localStorage */
export function toEvaCompanyLight(c: EvaCompany | any): EvaCompanyLight {
  return {
    eva_company_id: c.eva_company_id,
    name: c.name,
    name_initials: c.name_initials ?? "",
    company_color: c.company_color ?? "",
    country: c.country ?? "CH",
    primaryCurrency: c.primaryCurrency ?? "CHF",
  };
}
